<template lang="pug">
  div
    .d-flex.flex-row.align-items-center
      font-awesome-icon.account-page__icon(:icon="['far', 'comment-alt-dollar']")
      h3.account-page__title {{ trans('menus.frontend.navigation.payment-notify') }}
    payment-confirmation-box
</template>

<script>
import BreadcrumbsManager from '../../../../mixins/BreadcrumbsManager';
import PaymentConfirmationBox from '../../../../components/payment/PaymentConfirmationBox.vue';
import { RepositoryFactory } from '../../../../repositoryFactory';

const OrderRepository = RepositoryFactory.get('order');

export default {
  components: {
    PaymentConfirmationBox,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('menus.frontend.navigation.payment-notify'),
    };
  },
  data() {
    return {
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('menus.frontend.navigation.payment-notify') },
    ]);
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async getOrders() {
      const { data } = await OrderRepository.get({ paginated: false, sort: 'created_at|desc' }).then((resp) => resp.data);
      this.orders = data;
    },
  },
};
</script>
